import React from 'react';
import { array, bool, string } from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import Variations from '../Variations';
import { useChooseVariationContext } from '../Context';
import './style.scss';

const VariationsSection = ({ variations, isProjectOwner, copiesKey, withoutTitle = false }) =>
    !!variations.length && (
        <div className="variations-carousel-item">
            {!withoutTitle && (
                <h6>
                    <I18n k={`logo_maker_perseus.choose_variation.thumbnails.${copiesKey}.title`} />
                </h6>
            )}
            <Variations variations={variations} isProjectOwner={isProjectOwner} />
        </div>
    );

VariationsSection.propTypes = {
    variations: array,
    isProjectOwner: bool,
    copiesKey: string,
    withoutTitle: bool,
};

const VariationsCarousel = ({ className, isProjectOwner = false }) => {
    const { draftVariations, orderedVariations, suggestedVariations } = useChooseVariationContext();
    return (
        <div className={classnames('variations-carousel', className)}>
            <VariationsSection variations={draftVariations} isProjectOwner={isProjectOwner} copiesKey="your_designs" />
            <VariationsSection variations={orderedVariations} isProjectOwner={isProjectOwner} copiesKey="your_orders" />
            <VariationsSection
                variations={suggestedVariations}
                isProjectOwner={isProjectOwner}
                copiesKey="designer_recommended"
                withoutTitle={!draftVariations.length && !orderedVariations.length}
            />
        </div>
    );
};

VariationsCarousel.propTypes = {
    className: string,
    isProjectOwner: bool,
};

export default VariationsCarousel;
